import { __awaiter, __generator } from 'tslib';
import { useCallback } from 'react';
import { useAnalytics } from '../../../../analytics/hooks.js';
import '../../../../analytics/context.js';
import { FORM_FIELDS_LABELS_CONFIG } from '../../../../constants/form.js';
import '../../../../constants/sources.js';
import { EVENT_TYPE } from '../../constants.js';
import { useSelectionCalculator, useSelectionCalculatorActions } from '../../hooks.js';

var useFormOnBlur = function (form) {
    var _a = useAnalytics(), pushEvent = _a.pushEvent, eventLabelPage = _a.eventLabelPage;
    var _b = useSelectionCalculator(), formValues = _b.formValues, onEvent = _b.onEvent;
    var updateFormData = useSelectionCalculatorActions().updateFormData;
    var trigger = form.trigger, getValues = form.getValues;
    return useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var fieldName, value, isValid, fieldLabel;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fieldName = event.target.name;
                    if (!fieldName) {
                        return [2 /*return*/];
                    }
                    value = getValues(fieldName);
                    if (formValues[fieldName] === value) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, trigger(fieldName)];
                case 1:
                    isValid = _b.sent();
                    if (isValid) {
                        updateFormData(fieldName, value);
                    }
                    fieldLabel = ((_a = FORM_FIELDS_LABELS_CONFIG[fieldName]) === null || _a === void 0 ? void 0 : _a.text) || fieldName;
                    if (isValid) {
                        if (onEvent) {
                            onEvent({
                                type: EVENT_TYPE.CALCULATOR_PARAM_CHANGED,
                                payload: {
                                    fieldName: fieldName,
                                    fieldLabel: fieldLabel,
                                    fieldValue: value,
                                    page: eventLabelPage,
                                },
                            });
                        }
                    }
                    else if (onEvent) {
                        onEvent({
                            type: EVENT_TYPE.CALCULATOR_PARAM_ERROR,
                            payload: {
                                fieldName: fieldName,
                                fieldLabel: fieldLabel,
                                fieldValue: value,
                            },
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); }, 
    // ignore analyticsEvents object
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, trigger, pushEvent, getValues, updateFormData, formValues]);
};

export { useFormOnBlur };
//# sourceMappingURL=hooks.js.map
